import { Component, NgModule } from '@angular/core';
import { SiteBrowserState } from '../../core/util/site-browser.state';
import { SiteBrowserService } from '../../core/util/site-browser.service';
import { SettingsStorageService } from '../../core/util/settings-storage.service';
import { NotificationService } from '../../core/util/notification.service';
import { CommonModule } from '@angular/common';
import { DataTableModule } from 'primeng/components/datatable/datatable';
import { FileService } from '../../core/file/file.services';
/**
 * The SiteDataTableComponent is a PrimeNG Component which provides a DataTable to display dotCMS Host/Folder Navigation
 * The Component is Supscribed to the [[SiteBrowserState]] to monitor when Folders and Site changes occur
 * In additiont to this it will respond to dragging Files and Folders from the local filesystem and upload them to dotCMS
 * The SiteDataTableComponent is able to display [[Treeable]] assets
 */
var SiteDatatableComponent = (function () {
    function SiteDatatableComponent(updateService, fileService, siteBrowserService, settingsStorageService, messageService) {
        var _this = this;
        this.updateService = updateService;
        this.fileService = fileService;
        this.siteBrowserService = siteBrowserService;
        this.settingsStorageService = settingsStorageService;
        this.messageService = messageService;
        this.dotCMSURL = '';
        if (settingsStorageService.getSettings()) {
            this.dotCMSURL = settingsStorageService.getSettings().site;
        }
        this.site = updateService.getSelectedSite();
        if (updateService.getURI()) {
            this.loadFolder(updateService.getURI());
        }
        updateService.currentSite
            .subscribe(function (site) {
            if (site && site.hostname) {
                _this.loadSite(site);
            }
        });
        updateService.currentURI
            .subscribe(function (uri) {
            if (uri) {
                _this.loadFolder(uri);
            }
        });
        setTimeout(function () {
        }, 100);
    }
    /**
     * Listens to the double click event.  If the row clicked is a folder the [[SiteBrowserState]] will be called to
     * change the folder. This will cause this component to load the new folder and of course anyone else
     * subscribed to the [[SiteBrowserState]] folder state
     * @param event
     */
    SiteDatatableComponent.prototype.doubleClick = function (event) {
        if (event.data.type !== 'folder') {
            return;
        }
        var pathName = event.data.path;
        pathName = pathName.slice(0, pathName.length - 1);
        pathName = pathName.slice(pathName.lastIndexOf('/') + 1, pathName.length);
        this.updateService.changeFolder(pathName);
        this.updateService.changeURI(event.data.path);
        var folder = event.data;
        var uri = this.updateService.getURI();
        if (!uri) {
            uri = '';
        }
        this.loadFolder(folder.path);
        setTimeout(function () {
        }, 100);
    };
    /**
     * On single click of a row this function will update the [[SiteBrowserState]] selected [[Treeable]]
     * @param event
     */
    SiteDatatableComponent.prototype.selectTreeable = function (event) {
        this.updateService.changeTreeable(event.data);
    };
    /**
     * This function is called when the [[SiteBrowserState]] uri is changed
     * @param uri
     */
    SiteDatatableComponent.prototype.loadFolder = function (uri) {
        var _this = this;
        this.siteBrowserService.getTreeableAssetsUnderFolder(this.site.hostname, uri)
            .subscribe(function (treeables) { return _this.treeables = treeables; });
        setTimeout(function () { }, 100);
    };
    /**
     * This function is called when the [[SiteBrowserState]] Site is changed
     * @param siteName
     */
    SiteDatatableComponent.prototype.loadSite = function (site) {
        var _this = this;
        this.site = site;
        this.siteBrowserService.getTreeableAssetsUnderSite(site.hostname)
            .subscribe(function (treeables) { return _this.treeables = treeables; });
        setTimeout(function () { }, 100);
    };
    SiteDatatableComponent.prototype.handleDragOver = function (e) { };
    /**
     * Deals with the drop of 1 to many files and folders from the filesystem
     * @param e
     * @returns {boolean}
     */
    SiteDatatableComponent.prototype.handleDrop = function (e) {
        e.preventDefault();
        var pathToUploadTo;
        var fileContentTypeID;
        var dataTrans = e.dataTransfer;
        var fileName = e.dataTransfer.files[0].name;
        var files = e.dataTransfer.files;
        var folderTitle = e.path[0].innerText.trim();
        for (var i = 0; i < this.treeables.length; i++) {
            var node = this.treeables[i];
            if (node.title === folderTitle && node.type === 'folder') {
                pathToUploadTo = node.path;
                fileContentTypeID = node.defaultFileType;
                break;
            }
        }
        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            if (fileContentTypeID == null || fileContentTypeID.trim() === '') {
                console.error('st inode is empty');
            }
            this.fileService.uploadFile(file, pathToUploadTo, fileContentTypeID);
        }
        this.messageService.displayInfoMessage('Path is ' + pathToUploadTo);
        return;
    };
    return SiteDatatableComponent;
}());
export { SiteDatatableComponent };
SiteDatatableComponent.decorators = [
    { type: Component, args: [{
                selector: 'site-datatable',
                styles: [require('./../app.css')],
                template: "<div (drop)=\"handleDrop($event, p-column)\" (dragover)=\"handleDragOver($event)\">\n        <p-dataTable [value]=\"treeables\" selectionMode=\"single\"\n                     (onRowDblclick)=\"doubleClick($event)\" (onRowSelect)=\"selectTreeable($event)\">\n            <p-column class=\"browser-dropzone\" field=\"title\" header=\"Name\" [sortable]=\"true\">\n                <ng-template let-col let-treeable=\"rowData\" pTemplate type=\"body\">\n                <span [ngSwitch]=\"treeable.type\">\n                    <span *ngSwitchCase=\"'folder'\" class=\"{{treeable.type=='folder' ? 'fa fa-folder aria-hidden=true':''}}\"></span>\n                    <span *ngSwitchCase=\"'file_asset'\">\n                        <img *ngIf=\"treeable.isImage() && treeable.extension!='ico'\" src=\"{{dotCMSURL}}/contentAsset/image/{{treeable.identifier}}/fileAsset/filter/Thumbnail/thumbnail_w/25/thumbnail_h/25\">\n                        <span *ngIf=\"!treeable.isImage() || treeable.extension=='ico'\" class=\"fa fa-file\" aria-hidden=\"true\"></span>\n                    </span>\n                </span>\n                    <span>{{treeable.title}}</span>\n                </ng-template>\n            </p-column>\n            <p-column field=\"type\" header=\"Type\" [sortable]=\"true\" [style]=\"{'width':'100px'}\">\n                <ng-template let-col let-treeable=\"rowData\" pTemplate type=\"body\">\n                    <span>{{treeable.displayType}}</span>\n                </ng-template>\n            </p-column>\n            <p-column field=\"live\" header=\"Status\" [style]=\"{'width':'70px'}\">\n                <ng-template let-col let-treeable=\"rowData\" pTemplate type=\"body\">\n                    <div *ngIf=\"treeable.type=='file_asset'\">\n                        <span *ngIf=\"treeable.live\" class=\"liveIcon\"></span>\n                        <span *ngIf=\"!treeable.live\" class=\"workingIcon\"></span>\n                    </div>\n                </ng-template>\n            </p-column>\n            <p-column field=\"modUserName\" header=\"Editor\" [sortable]=\"true\" [style]=\"{'width':'150px'}\"></p-column>\n            <p-column field=\"modDate\" header=\"Modified\" [sortable]=\"true\" [style]=\"{'width':'200px'}\">\n                <ng-template let-col let-treeable=\"rowData\" pTemplate type=\"body\">\n                    <span>{{treeable.modDate | date: 'MM/dd/yy hh:mm:ss a'}}</span>\n                </ng-template>\n            </p-column>\n        </p-dataTable>\n    </div>"
            },] },
];
/** @nocollapse */
SiteDatatableComponent.ctorParameters = function () { return [
    { type: SiteBrowserState, },
    { type: FileService, },
    { type: SiteBrowserService, },
    { type: SettingsStorageService, },
    { type: NotificationService, },
]; };
var DotSiteDatatableModule = (function () {
    function DotSiteDatatableModule() {
    }
    return DotSiteDatatableModule;
}());
export { DotSiteDatatableModule };
DotSiteDatatableModule.decorators = [
    { type: NgModule, args: [{
                declarations: [SiteDatatableComponent],
                exports: [SiteDatatableComponent],
                imports: [CommonModule, DataTableModule],
                providers: [FileService, SiteBrowserService, SettingsStorageService, NotificationService]
            },] },
];
/** @nocollapse */
DotSiteDatatableModule.ctorParameters = function () { return []; };
//# sourceMappingURL=site-datatable.component.js.map